import React, {  useState } from "react";
import { InputComponent } from "../../common/InputComponent/InputComponent";
import * as Yup from "yup"
import { useFormik,FormikHelpers } from "formik";
import Divider from "../../common/Divider";
import { useRecoilState } from "recoil";
import UserState from "../../../recoil/UserState";
import { useNavigate } from "react-router-dom";
import { socialSignIn } from "../../../services/common";
import Google from "../../common/icons/Google";
import Facebook from "../../common/icons/Facebook";
import { signUp } from "../../../services/api";
import Twitter from "../../common/icons/Twitter";

interface Values {
    email:string,
    password:string,
    confirm_password:string
}

interface MsgObject {
  Msg: string,
  Status: string,
}

interface LoginResponse {
  access_token: string;
} 

const signupSchema= ()=>Yup.object().shape({
    email:Yup.string().email("Email must be valid").required("Email is required"),
    password:Yup.string().min(8).required("Password is required"),
    confirm_password:Yup.string().oneOf([Yup.ref('password')],"Confirm password does not match").required("Please confirm your password"),
})

const Signup: React.FC = () => {
  const navigate = useNavigate();
  const [user,setUser] = useRecoilState(UserState)
  const [error,setError] = useState()
  const [accCreatedMsg, setAccCreatedMsg] = useState<MsgObject>({Msg:'', Status: ""})
  const [data, setData] = useState({
    email: "",
    password: "",
    confirm_password: "",
  });

  const handleSignup = async (values:Values,{resetForm}:FormikHelpers<Values>) => {
    let res = await signUp(values)
    if(res.status==200||res.status==201){
      setAccCreatedMsg({Msg:res.data.message, Status:'success'})
    } else {
      setAccCreatedMsg({Msg:res.data.message, Status:'failed'})
    }
  };

  const handleSocialLogin = async (socialMedia:string) => {
    let res:any = await socialSignIn(socialMedia)
    if(res.access_token){
      setUser({...user, isAuthenticated:true})
      navigate("/")
    }
  };

  const formik = useFormik({
    initialValues:{
    email: "",
    password: "",
    confirm_password: ""},
    validationSchema:signupSchema,
    validateOnChange:false,
    onSubmit:handleSignup
  })

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex flex-col">
        <div>
          <div className="p-2 ml-6">
            <div className="w-22 py-2 ml-6">
              <img src="/images/logo.png" alt="taotensor" />
            </div>
          </div>
        </div>
        <div className="flex-1 flex justify-center align-center">
        <div className="px-12 min-w-500">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex items-center mb-2 justify-center">
              <h4 className="custom-font text-4xl text-mid-gray">Sign Up</h4>
            </div>
            <div className="pt-2 flex flex-col">
              <InputComponent
                type="text"
                value={formik.values.email}
                error={formik.errors.email}
                showErrorMessage
                containerClassName={"mt-2"}
                name="email"
                onChange={formik.handleChange}
                labelText={"Email"}
              />
              <InputComponent
                name="password"
                type="password"
                error={formik.errors.password}
                showErrorMessage
                value={formik.values.password}
                containerClassName={"mt-2"}
                onChange={formik.handleChange}
                labelText={"Password"}
              />
              <InputComponent
                name="confirm_password"
                error={formik.errors.confirm_password}
                showErrorMessage
                type="password"
                value={formik.values.confirm_password}
                containerClassName={"my-2"}
                onChange={formik.handleChange}
                labelText={"Confirm Password"}
                />
              <button type="submit" className="custom-font bg-primary rounded-full border-1 border-c-gray text-button-text p-1 hover:bg-secondary hover:text-button-text-hover transition duration-300 ease-in-out" disabled={formik.isSubmitting}>
                Sign Up
              </button>
              {accCreatedMsg.Msg && accCreatedMsg.Msg!='' && <p className={`text-sm pt-2 ${accCreatedMsg.Status == 'success' ? 'text-green' : 'text-red'}`}>{accCreatedMsg.Msg}</p>}
              <p className="text-sm text-darker-gray pt-2">Already have an account? <span className="cursor-pointer hover:text-blue" onClick={()=>navigate("/login")}>Sign In</span></p>
            </div>
          </form>
          <Divider containerClassName="my-2" text="or"/>
          <div className="w-full flex flex-col">
              <button onClick={()=>handleSocialLogin('google')} className="flex justify-center align-center mb-2 custom-font bg-white rounded-full border-1 border-black text-black py-1 hover:bg-gray-200 transition duration-300 ease-in-out">
                <Google/> <span className="pl-2">Sign Up with Google</span>
              </button>
              <button onClick={()=>handleSocialLogin('twitter')} className="flex justify-center align-center custom-font bg-white rounded-full border-1 border-black text-black p-1 hover:bg-gray-200 transition duration-300 ease-in-out">
                <Twitter /> <span className="pl-2">Sign Up with Twitter</span>
              </button>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;